import { render, staticRenderFns } from "./DocumentsView.vue?vue&type=template&id=bc9fe53e&scoped=true"
import script from "./DocumentsView.vue?vue&type=script&lang=ts"
export * from "./DocumentsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9fe53e",
  null
  
)

export default component.exports